module.exports = __webpack_public_path__ + "assets/AppStoreBadgeWhite_US.0f3514a45d51f95167e5fe8b6a03bb60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/buttons/AppStoreBadgeWhite_US.svg
// module id = 182
// module chunks = 0